import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';
import { SmarshToasterData } from '@smarsh-cyber/shared/component';

@Injectable()
export class SmarshToasterService {
  observable: Subject<SmarshToasterData> = new Subject<SmarshToasterData>();
  constructor() {}
  onChange(): Subject<SmarshToasterData> {
    return this.observable;
  }
  emit(value: SmarshToasterData) {
    this.observable.next(value);
  }
}
